__turbopack_context__.v({
  "arrowBtn": "custom-module__mjgpZq__arrowBtn",
  "audioAgentName": "custom-module__mjgpZq__audioAgentName",
  "audioAgentStatus": "custom-module__mjgpZq__audioAgentStatus",
  "audioAvatar": "custom-module__mjgpZq__audioAvatar",
  "audioLabel": "custom-module__mjgpZq__audioLabel",
  "audioPlayBtn": "custom-module__mjgpZq__audioPlayBtn",
  "audioPlayIcon": "custom-module__mjgpZq__audioPlayIcon",
  "audioStatusDot": "custom-module__mjgpZq__audioStatusDot",
  "audioStatusDotActive": "custom-module__mjgpZq__audioStatusDotActive",
  "audioWaveBar": "custom-module__mjgpZq__audioWaveBar",
  "audioWaveBarActive": "custom-module__mjgpZq__audioWaveBarActive",
  "audioWaveform": "custom-module__mjgpZq__audioWaveform",
  "audioWidget": "custom-module__mjgpZq__audioWidget",
  "audioWidgetHeader": "custom-module__mjgpZq__audioWidgetHeader",
  "ctaBtn": "custom-module__mjgpZq__ctaBtn",
  "ctaImage": "custom-module__mjgpZq__ctaImage",
  "ctaInner": "custom-module__mjgpZq__ctaInner",
  "ctaOverlay": "custom-module__mjgpZq__ctaOverlay",
  "ctaSection": "custom-module__mjgpZq__ctaSection",
  "ctaSubtitle": "custom-module__mjgpZq__ctaSubtitle",
  "ctaTitle": "custom-module__mjgpZq__ctaTitle",
  "fcIllusArea": "custom-module__mjgpZq__fcIllusArea",
  "fcPulse": "custom-module__mjgpZq__fcPulse",
  "fcSubtitle": "custom-module__mjgpZq__fcSubtitle",
  "fcTextArea": "custom-module__mjgpZq__fcTextArea",
  "fcTitle": "custom-module__mjgpZq__fcTitle",
  "fcWave": "custom-module__mjgpZq__fcWave",
  "featureCard": "custom-module__mjgpZq__featureCard",
  "featuresGrid": "custom-module__mjgpZq__featuresGrid",
  "featuresInner": "custom-module__mjgpZq__featuresInner",
  "featuresSection": "custom-module__mjgpZq__featuresSection",
  "hero": "custom-module__mjgpZq__hero",
  "heroBtnPrimary": "custom-module__mjgpZq__heroBtnPrimary",
  "heroBtnSecondary": "custom-module__mjgpZq__heroBtnSecondary",
  "heroBtns": "custom-module__mjgpZq__heroBtns",
  "heroContent": "custom-module__mjgpZq__heroContent",
  "heroImage": "custom-module__mjgpZq__heroImage",
  "heroLayout": "custom-module__mjgpZq__heroLayout",
  "heroOverlay": "custom-module__mjgpZq__heroOverlay",
  "heroSubtitle": "custom-module__mjgpZq__heroSubtitle",
  "heroTag": "custom-module__mjgpZq__heroTag",
  "heroTitle": "custom-module__mjgpZq__heroTitle",
  "howItWorksHeader": "custom-module__mjgpZq__howItWorksHeader",
  "howItWorksSection": "custom-module__mjgpZq__howItWorksSection",
  "howSubtitle": "custom-module__mjgpZq__howSubtitle",
  "howTitle": "custom-module__mjgpZq__howTitle",
  "howTitleItalic": "custom-module__mjgpZq__howTitleItalic",
  "illusDiscovery": "custom-module__mjgpZq__illusDiscovery",
  "illusDiscoveryCard": "custom-module__mjgpZq__illusDiscoveryCard",
  "illusDiscoveryRow": "custom-module__mjgpZq__illusDiscoveryRow",
  "illusDiscoveryTitle": "custom-module__mjgpZq__illusDiscoveryTitle",
  "illusIntBadge": "custom-module__mjgpZq__illusIntBadge",
  "illusIntCard": "custom-module__mjgpZq__illusIntCard",
  "illusIntRow": "custom-module__mjgpZq__illusIntRow",
  "illusIntTitle": "custom-module__mjgpZq__illusIntTitle",
  "illusLive": "custom-module__mjgpZq__illusLive",
  "illusLiveBadge": "custom-module__mjgpZq__illusLiveBadge",
  "illusLiveDot": "custom-module__mjgpZq__illusLiveDot",
  "illusLiveList": "custom-module__mjgpZq__illusLiveList",
  "illusPanel": "custom-module__mjgpZq__illusPanel",
  "illusPanelLabel": "custom-module__mjgpZq__illusPanelLabel",
  "illusPanelOn": "custom-module__mjgpZq__illusPanelOn",
  "illusPanelRow": "custom-module__mjgpZq__illusPanelRow",
  "illusPanelValue": "custom-module__mjgpZq__illusPanelValue",
  "illusPhone": "custom-module__mjgpZq__illusPhone",
  "illusPhoneBadge": "custom-module__mjgpZq__illusPhoneBadge",
  "illusPhoneLabel": "custom-module__mjgpZq__illusPhoneLabel",
  "illusPhoneNum": "custom-module__mjgpZq__illusPhoneNum",
  "illusScriptBadge": "custom-module__mjgpZq__illusScriptBadge",
  "illusScriptCard": "custom-module__mjgpZq__illusScriptCard",
  "illusScriptRow": "custom-module__mjgpZq__illusScriptRow",
  "illusScriptTitle": "custom-module__mjgpZq__illusScriptTitle",
  "illusSupportBadge": "custom-module__mjgpZq__illusSupportBadge",
  "illusSupportCard": "custom-module__mjgpZq__illusSupportCard",
  "illusSupportRow": "custom-module__mjgpZq__illusSupportRow",
  "illusSupportTitle": "custom-module__mjgpZq__illusSupportTitle",
  "illusTeamBadge": "custom-module__mjgpZq__illusTeamBadge",
  "illusTeamCard": "custom-module__mjgpZq__illusTeamCard",
  "illusTeamRow": "custom-module__mjgpZq__illusTeamRow",
  "illusTeamTitle": "custom-module__mjgpZq__illusTeamTitle",
  "illusTestBadge": "custom-module__mjgpZq__illusTestBadge",
  "illusTestCard": "custom-module__mjgpZq__illusTestCard",
  "illusTestGreen": "custom-module__mjgpZq__illusTestGreen",
  "illusTestRow": "custom-module__mjgpZq__illusTestRow",
  "illusTestTitle": "custom-module__mjgpZq__illusTestTitle",
  "illusVoiceBadge": "custom-module__mjgpZq__illusVoiceBadge",
  "illusVoiceCard": "custom-module__mjgpZq__illusVoiceCard",
  "illusVoiceRow": "custom-module__mjgpZq__illusVoiceRow",
  "illusVoiceTitle": "custom-module__mjgpZq__illusVoiceTitle",
  "illusWorkflowBadge": "custom-module__mjgpZq__illusWorkflowBadge",
  "illusWorkflowCard": "custom-module__mjgpZq__illusWorkflowCard",
  "illusWorkflowRow": "custom-module__mjgpZq__illusWorkflowRow",
  "illusWorkflowTitle": "custom-module__mjgpZq__illusWorkflowTitle",
  "livePulse": "custom-module__mjgpZq__livePulse",
  "page": "custom-module__mjgpZq__page",
  "sectionHeader": "custom-module__mjgpZq__sectionHeader",
  "sectionLabel": "custom-module__mjgpZq__sectionLabel",
  "slideCard": "custom-module__mjgpZq__slideCard",
  "slideCard1": "custom-module__mjgpZq__slideCard1",
  "slideCard2": "custom-module__mjgpZq__slideCard2",
  "slideCard3": "custom-module__mjgpZq__slideCard3",
  "slideCard4": "custom-module__mjgpZq__slideCard4",
  "slideDesc": "custom-module__mjgpZq__slideDesc",
  "slideIllus": "custom-module__mjgpZq__slideIllus",
  "slideNum": "custom-module__mjgpZq__slideNum",
  "slideText": "custom-module__mjgpZq__slideText",
  "slideTitle": "custom-module__mjgpZq__slideTitle",
  "sliderArrows": "custom-module__mjgpZq__sliderArrows",
  "sliderViewport": "custom-module__mjgpZq__sliderViewport",
});
